/**
 * Created by hieult on 2/14/18.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function appStateReducer(state = initialState.appState, action) {
  switch (action.type) {
    case types.UPDATE_APP_STATE_SUCCESS: {
      const newState = action.data;

      return newState;
    }

    default:
      return state;
  }
}
